import Quill from "quill";

const RichTextEditorHook = {
  mounted() {
    const elementId = this.el.id;
    const quillContainer = `#${elementId}-container`;
    const inputQuerySelector = this.el.dataset.inputQuerySelector;
    const placeholder = this.el.dataset.placeholder;

    const options = {
      theme: "snow",
      // Set the bounds to the container so tooltips aren't cut off when used within a modal
      bounds: `#${elementId}-container`,
      // Only add placeholder to options if it was provided in the data attribute
      ...(placeholder && { placeholder }),
    };

    const quill = new Quill(quillContainer, options);

    quill.on("text-change", () => {
      const input = document.querySelector(inputQuerySelector);
      // We get the semantic HTML then replace the last non-breaking space with a regular space.
      // The replaceAll method is a temporary fix for https://github.com/slab/quill/issues/4509
      const html = quill
        .getSemanticHTML()
        .replaceAll(/((?:&nbsp;)*)&nbsp;/g, "$1 ");

      input.value = html;

      // Dispatch a change event so LiveView phx-change can detect the change
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  },
};
export default RichTextEditorHook;
